<div (click)="open('/main/proximity-sample-points')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    @if (loading()) {
        <lib-loading-placeholder [show]="loading()"/>
    } @else {
        <div class=" d-flex justify-content-between">
            <div class=" fs-main fw-bold mb-3">BLE scanners</div>
            <div class=" mt-auto mb-auto">
                <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
            </div>
        </div>
        <div class="row">
            @if (onlineProximitySamplePoints().length > 0) {
                <div class="col-auto ps-2 pe-0">
                    <app-bluetooth-svg
                        [height]="'32px'"
                        [status]="Status.ONLINE"
                        [width]="'32px'"
                        class="img-fluid img-max m-auto"/>
                    <span class="m-2">{{ onlineProximitySamplePoints().length }}</span>
                </div>
            }
            @if (offlineProximitySamplePoints().length > 0) {
                <div class="col-auto ps-2 pe-0">
                    <app-bluetooth-svg
                        [height]="'32px'"
                        [status]="Status.OFFLINE"
                        [width]="'32px'"
                        class="img-fluid img-max m-auto"/>
                    <span class="m-2">{{ offlineProximitySamplePoints().length }}</span>
                </div>
            }
            @if (unassignedBluetoothProximitySensors().length > 0) {
                <div class="col-auto ps-2 pe-0">
                    <app-bluetooth-svg
                        [height]="'32px'"
                        [status]="Status.READY_FOR_ONBOARDING"
                        [width]="'32px'"
                        class="img-fluid img-max m-auto"/>
                    <span class="m-2">{{ unassignedBluetoothProximitySensors().length }}</span>
                </div>
            }
        </div>
    }
</div>
